var $ = require('jquery');
const _ = require('lodash');
/* Utility functions */
function createSimpleClarityToolTip( elementHTML: string = '<span>tooltip</span>', tooltipText: string = 'Tooltip text', tooltipClasses: string = '"tooltip tooltip-sm tooltip-right"' ) {
    return '<span role="tooltip" aria-haspopup="true" class="' + tooltipClasses + '">' +
                elementHTML +
                '<span class="tooltip-content">' + tooltipText + '</span>' +
            '</span>';
}

function prettyUserName(userName) {
    /* Example: it returns "orgadmin" from "orgadmin@abcd-erfv-vfre-aswq-mkiujn" */
    if (userName) {
        userName = (userName.lastIndexOf("@") > -1) ? userName.substring(0,userName.lastIndexOf("@")) : userName;
    }
    return userName;
}

let Objectifier = (function() {
    // Utility method to get and set objects that may or may not exist
    let objectifier = function(splits, create, context) {
        let result = context || window;
        for(let i = 0, s; result && (s = splits[i]); i++) {
            result = (s in result ? result[s] : (create ? result[s] = {} : undefined));
        }
        return result;
    };

    return {
        // Creates an object if it doesn't already exist
        set: function(name, value, context) {
            let splits = name.split('.'), s = splits.pop(), result = objectifier(splits, true, context);
            return result && s ? (result[s] = value) : undefined;
        },
        get: function(name, create, context) {
            return objectifier(name.split('.'), create, context);
        },
        exists: function(name, context) {
            return this.get(name, false, context) !== undefined;
        }
    };

})();

function changeFavicon(link) {
    let favicon = document.querySelector('link[rel="icon"]');
    if (favicon !== null) {
        favicon['href'] = link;
    } else {
        favicon = document.createElement('link');
        favicon['rel']= 'icon';
        favicon['href'] = link;
        document.head.appendChild(favicon);
    }
}


function storagePrettyConverter(storage, unit, retObj:boolean = false) {
    var returnString = storage + " " +  (unit ? unit : "");
    var resultObj: any = { number: storage, unit: unit };
    if(storage && unit){
        resultObj = unitConverter(Number(storage), unit);
        returnString = resultObj.number + ' ' + resultObj.unit;
    }
    if (retObj == true && storage && unit) {
        return resultObj;
    } else {
        return returnString;
    }
}

function unitConverter(number, unit, significantDigitCount = 3) {
  var unitPrefixes = [' ', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  if (number == 0) {
      return {
          number: number,
          unit: unit
      };
  }
  var power = Math.log(number > 0 ? number: -number) / Math.LN10;
  var roundedPower = Math.floor(power);
  if (roundedPower + 1 - power < 0.000001) { // To handle round-off errors in cases like 1000 MHz
      roundedPower += 1;
  }
  var unitShift = Math.floor(roundedPower/3);
  var newNumber = 0;
  if (unit.charAt(0) == 'B' || unit.charAt(1) == 'B') {  // bytes case
      newNumber = number / Math.pow(1024, unitShift);
  } else {
      newNumber = number / Math.pow(10, 3*unitShift);
  }
  var trimmedNumber:any = (Math.round(newNumber * Math.pow(10, significantDigitCount - 1)))/Math.pow(10, significantDigitCount - 1);
  var newUnit = '';
  var newUnitPrefix = '';
  var newUnitPrefixPosition = $.inArray(unit.charAt(0), unitPrefixes) + unitShift;
  if (newUnitPrefixPosition >=0 && newUnitPrefixPosition <= 8) {
      newUnitPrefix = unitPrefixes[newUnitPrefixPosition];
      newUnit = newUnitPrefix.concat(unit.substr(1));
  } else {  // doesn't handle extreme cases
      return {
          number: number,
          unit: unit
      };
  }
  var toBeFixed = significantDigitCount - (roundedPower - 3*unitShift) -1;
  if (toBeFixed >= 0) {
      trimmedNumber = trimmedNumber.toFixed(toBeFixed);
  }
  return {
      number: trimmedNumber,
      unit: newUnit
  };
}

function convertToHex(str: string) {
    let hex = '';
    for (let i = 0; i < str.length; i++) {
        hex += '' + str.charCodeAt(i).toString(16);
    }
    return hex;
}

function setVcdRedirectUrlCookie(orgName: string, cookieRawValue: string) {
    let hexEncodedUrl = convertToHex(cookieRawValue);
    let cookieName = 'redirectUrl_' + orgName;
    let cookiePath = '/';
    setCookie(cookieName, hexEncodedUrl, cookiePath);
}

function setCookie(cookieName: string, cookieValue: string, cookiePath: string) {
    let cookieToSet = cookieName + '=' + cookieValue;
    document.cookie = cookieToSet + ';path=' + cookiePath;
}

/*
    ... Checking Vi Administrator / lesser role user
    ... if roles[] doesn’t contains any of these three
        “Organization Administrator”  “Enterprise Administrator”  “System Administrator”
        will be considered as lesser permissions
*/
function checkIfUserHasRoles(roles: any) {
    if (_.includes(roles, 'Organization Administrator') || _.includes(roles, 'Enterprise Administrator') || _.includes(roles, 'System Administrator') ) {
        return true;
    } else {
        return false;
    }
}

var dateFormat = require('dateformat');
function formatDateTimeCustom(timestamp, format: string = "ddd mmm dd yyyy HH:MM:ss Z") {
       if (!timestamp) {
           return '';
       }
       try {
            return dateFormat(timestamp, format);
       } catch(err) {
            return '';
       }

    }

/* Export section */
export { createSimpleClarityToolTip as createToolTip, Objectifier, prettyUserName, changeFavicon, storagePrettyConverter, setVcdRedirectUrlCookie, formatDateTimeCustom, checkIfUserHasRoles };



// WEBPACK FOOTER //
// ./src/common/utils/utils.ts